import { createContext, useState, useEffect } from "react";
import jwt_decode from "jwt-decode";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";

const AuthContext = createContext();

export default AuthContext;

export const AuthProvider = ({ children }) => {
  let [authTokens, setAuthTokens] = useState(() =>
    localStorage.getItem("authTokens")
      ? JSON.parse(localStorage.getItem("authTokens"))
      : null
  );
  let [user, setUser] = useState(() =>
    localStorage.getItem("authTokens")
      ? jwt_decode(localStorage.getItem("authTokens"))
      : null
  );
  let [loading, setLoading] = useState(true);
  let [errorMessage, setErrorMessage] = useState(null);
  let [isAdmin, setisAdmin] = useState(null);
  let [passReset, setPassReset] = useState(false);

  let navigate = useNavigate();

  let loginUser = async (e) => {
    e.preventDefault();
    let response = await fetch(
      "https://panelapi-dev.budapester.com/login_check",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          username: e.target.username.value,
          password: e.target.password.value,
        }),
      }
    );
    let data = await response.json();

    if (response.status === 200) {
      setErrorMessage(null);
      setAuthTokens(data);
      setLoading(true);
      setUser(jwt_decode(data.token));
      localStorage.setItem("authTokens", JSON.stringify(data));
      navigate("/");
    } else {
      setErrorMessage(data.message);
    }
  };

  let sendEmail = (email, subject, message) => {
    const data = {
      addressees: [
        {
          email: email,
        },
      ],
      subject: subject,
      html: message,
      text: "You see this if your e-mail client cannot html",
    };
    axios.post(`https://panelapi-dev.budapester.com/manager/mail`, data);
  };

  let resetPassword = async (e) => {
    e.preventDefault();

    const res = await axios.post(
      "https://panelapi-dev.budapester.com/password_reset/request_reset",
      {
        email: e.target.useremail.value,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "e928d148020eefe5959631da7c96083fe193c0a5",
        },
      }
    );

    if (res.status === 200) {
      setPassReset(true);
      sendEmail(
        e.target.useremail.value,
        `Link`,
        `${window.location.origin}/#/change-password/?token=${res.data.token}`
      );
    } else {
      setErrorMessage(res.data.message);
    }
  };

  let passChange = async (e) => {
    e.preventDefault();

    let res = await fetch(
      "https://panelapi-dev.budapester.com/password_reset/change_password",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "e928d148020eefe5959631da7c96083fe193c0a5",
        },
        body: JSON.stringify({
          token: e.target.id.value,
          newPassword: e.target.newpass.value,
        }),
      }
    );

    if (res.status === 200) {
      toast.success(`Password changed!`, {
        position: "bottom-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
      });
    } else {
      toast.error(`Error, please try again`, {
        position: "bottom-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
      });
    }
  };

  let logoutUser = () => {
    setAuthTokens(null);
    setUser(null);
    localStorage.removeItem("authTokens");
    navigate("/login");
    toast.info(`You are logout`, {
      position: "bottom-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: 0,
    });
  };

  let contextData = {
    user: user,
    authTokens: authTokens,
    errorMessage: errorMessage,
    setAuthTokens: setAuthTokens,
    setUser: setUser,
    loginUser: loginUser,
    resetPassword: resetPassword,
    logoutUser: logoutUser,
    passChange: passChange,
    passReset: passReset,
    isAdmin: isAdmin,
    setisAdmin: setisAdmin,
  };

  useEffect(() => {
    if (authTokens) {
      setUser(jwt_decode(authTokens.token));
    }
    setLoading(false);
  }, [authTokens, loading]);

  return (
    <AuthContext.Provider value={contextData}>
      {loading ? <>Loading...</> : children}
    </AuthContext.Provider>
  );
};
